import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Alert from '@components/Toaster/Alert';
import { Typography } from '@components/Typography';
import { isLegacyPaidPlan } from '@helpers/billing';
import { useTranslation } from '@hooks';

const StyledAlert = styled(Alert)({
    marginBottom: 16,
    alignItems: 'flex-start',
    '& .MuiAlert-icon': { marginTop: 2 },
});

const ListingIssuesBanner = () => {
    const account = useSelector(state => state.account?.account);
    const { conflictCount, notPublishedCount } = useSelector(state => state.profiles);
    const { t } = useTranslation();

    const issuesCount = (conflictCount ?? 0) + (notPublishedCount ?? 0);

    if (!account?.allowListingDirectories || isLegacyPaidPlan(account)) {
        return null;
    }

    if (!issuesCount) {
        return null;
    }

    return (
        <StyledAlert severity="warning">
            <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                {t('ProfilesPage.listingIssuesFound', { count: issuesCount })}
            </Typography>
            <Typography variant="caption" sx={{ display: 'block', color: 'inherit', opacity: 0.9 }}>
                {t('ProfilesPage.listingIssuesDescription')}
            </Typography>
        </StyledAlert>
    );
};

export default ListingIssuesBanner;
